import { Instagram, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { INSTAGRAM_URL } from "@/lib/site";

export default function InstagramBanner() {
  return (
    <section id="instagram" className="py-12 lg:py-20">
      <div className="mx-auto w-full max-w-7xl px-5 lg:px-8">
        <Reveal>
          <a
            data-testid="instagram-banner"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex flex-col items-center gap-6 rounded-3xl border border-neon/25 bg-gradient-to-r from-neon/10 via-ink to-neonblue/10 p-8 text-center transition-colors duration-300 hover:border-neon/60 lg:flex-row lg:justify-between lg:p-10 lg:text-left"
          >
            <div className="flex flex-col items-center gap-5 lg:flex-row">
              <span
                className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl text-white chip-glow transition-transform duration-300 group-hover:scale-110"
                style={{ background: "linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888)" }}
                aria-hidden="true"
              >
                <Instagram size={32} />
              </span>
              <div>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neon">Suivez-nous</p>
                <p className="mt-1 font-display text-3xl font-extrabold uppercase tracking-tight text-white sm:text-4xl">
                  @maxrevix sur Instagram
                </p>
                <p className="mt-2 max-w-md text-sm leading-relaxed text-slate-400">
                  Les coulisses de l'atelier : réparations avant/après, nouveautés boutique
                  et annonces en direct.
                </p>
              </div>
            </div>
            <span className="flex items-center gap-2 rounded-full bg-neon px-7 py-4 text-sm font-extrabold uppercase tracking-wider text-night chip-glow transition-transform duration-200 group-hover:scale-[1.04]">
              Suivre @maxrevix
              <ArrowUpRight size={17} />
            </span>
          </a>
        </Reveal>
      </div>
    </section>
  );
}